import category from "../../../assets/img/category1.svg"
import topic from "../../../assets/img/topic.svg"
import post from "../../../assets/img/post.svg"
import message from "../../../assets/img/message.svg"


export const menuChat = [
  {
    url: "/admin/chat-center/category",
    icon: category,
    title: "Category",
    description: "Organize content and discussions into structured groups",
  },
  {
    url: "/admin/chat-center/topic",
    icon: topic,
    title: "Topic",
    description: "Create conversation themes within each category",
  },
  {
    url: "/admin/chat-center/post",
    icon: post,
    title: "Post",
    description: "Share updates, questions, or information within a topic",
  },
  {
    url: "/admin/chat-center/message",
    icon: message,
    title: "Message",
    description: "Add responses or comments within a topic discussion",
  },
]